import { AppBar, Box, Divider, SxProps, Theme } from '@mui/material'

import Logo from 'components/Logo'
import BackButton from 'components/StepContainer/BackButton'
import { useCompany } from 'utils/company'
import { useIsPhone } from 'utils/hook'

import LoginToolbar from './Toolbar'

interface LoginHeaderProps {
  onPrev?: () => void
}

const styles: Record<string, SxProps<Theme>> = {
  appBar: {
    zIndex: (theme) => theme.zIndex.appBar + 1,
    bgcolor: '#FFFFFF',
    boxShadow: 'none',
  },
  backButton: {
    position: 'absolute',
    left: 10,
  },
}

export default function LoginHeader({ onPrev }: LoginHeaderProps): JSX.Element {
  const { data: company } = useCompany()

  return (
    <AppBar position="fixed" sx={styles.appBar}>
      <LoginToolbar>
        {onPrev !== undefined && (
          <Box sx={styles.backButton}>
            <BackButton onClick={onPrev} />
          </Box>
        )}
        <Logo logo={company?.logo ?? null} />
      </LoginToolbar>
      {useIsPhone() && <Divider />}
    </AppBar>
  )
}
